import { EditNoteOutlined as AmendmentIcon } from '@mui/icons-material';

const EmptyShippingSearch = () => {
  return (
    <div className='flex flex-col items-center justify-center py-28 px-4 text-center bg-white rounded-lg border border-gray-200'>
      <div className='w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm mb-4 border border-gray-100'>
        <AmendmentIcon className='text-gray-300' sx={{ fontSize: 32 }} />
      </div>
      <h3 className='text-gray-900 font-bold text-lg mb-1'>
        Selecciona un pedido para comenzar
      </h3>
      <p className='text-gray-400 text-sm max-w-[320px] font-medium'>
        Ingrese el número del pedido en el buscador superior.
      </p>
    </div>
  );
};

export default EmptyShippingSearch;
